import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import JSSHA from 'jssha';

import Storage from '_common/utils/Storage';

const HASH_KEY = '4144A3D0-821F-424C-836B-0575B86BD2AF';

export function generateHash(text) {
  if (text.length === 0) {
    return '';
  }
  const sha256 = new JSSHA('SHA-256', 'TEXT');
  sha256.update(text + HASH_KEY);
  return sha256.getHash('HEX');
}

export function setLoginNameGA() {
  const loginName = Storage.get('loginName') || '';
  const hash = generateHash(loginName);
  ReactGA.set({ userId: hash });
}

/**
 * A modal view is often an equivalent to a pageview in our UX,
 * but without a change in URL that would record a standard GA pageview.
 * For example, a 'contact us' modal may be accessible from any page in a site,
 * even if we don't have a standalone 'contact us' page on its own URL.
 * In this scenario, the modalview should be recorded using this function.
 */
export function eventRegisterGA() {
  ReactGA.event({
    category: 'Account',
    action: 'register',
    label: 'Account register',
  });
}

export function eventKycStepGA(step) {
  ReactGA.event({
    category: 'KYC',
    action: 'save',
    label: `KYC step ${step}`,
  });
}

export function eventKycSubmitGA() {
  ReactGA.event({
    category: 'KYC',
    action: 'submit',
    label: 'KYC submit',
  });
}

export function eventThirdPartyConversation() {
  console.log('eventThirdPartyConversation');
  const tagManagerArgs = {
    gtmId: 'GTM-MNBH5FGD',
  };
  TagManager.initialize(tagManagerArgs);
  TagManager.dataLayer({
    dataLayer: {
      event: 'conversion',
      send_to: 'AW-16895897643/ux85CL6ex6saEKvgy_g-',
    },
  });
}
